import { render } from "./SponsorTable.vue?vue&type=template&id=7e9df664"
import script from "./SponsorTable.vue?vue&type=script&lang=js"
export * from "./SponsorTable.vue?vue&type=script&lang=js"
script.render = render

export default script